import script from "./HealthReport.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthReport.vue?vue&type=script&setup=true&lang=js"

import "./HealthReport.vue?vue&type=style&index=0&id=37f14025&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f14025"]])

export default __exports__